// extracted by mini-css-extract-plugin
export var bodyRow = "_fh-d";
export var cardColumns = "_fh-e";
export var ellipsesOverflow = "_fh-2";
export var flatBottomCorners = "_fh-3";
export var flatTopCorners = "_fh-4";
export var headerActionsDropdown = "_fh-f";
export var headerBottomRow = "_fh-c";
export var headerTopRow = "_fh-b";
export var orderDetailsWrapper = "_fh-0";
export var orderInfoContainer = "_fh-1";
export var productDetails = "_fh-9";
export var productImage = "_fh-5";
export var responsiveTable = "_fh-8";
export var shipmentContainer = "_fh-a";
export var tableBottomLeft = "_fh-6";
export var tableBottomRight = "_fh-7";